<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/55/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/55/title-1.png" alt="" />
                    <div class="content">
                        与注册登记、税收解缴关系在我区的企业签订了劳动合同或劳务合同、技术合作协议、项目合作协议以及其他形式智力服务合作协议的各类人才。
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/55/title-2.png" alt="" />
                    <div class="content">
                        <div class="title" style="
                                            font-weight: bold;
                                            font-size: 0.34rem;
                                            margin-top: 0.13rem;
                                        ">
                            <span class="hollow-cricle"></span>（一）个体引进条件
                        </div>
                        <div class="des">
                            申报人根据自身条件，按照A类（国际顶尖）、B类（国家领军）、C类（地方高级）、D类（骨干精英）四类进行个体申报。申报人应是D类及以上级别人才，年龄原则上一般不超过55周岁，掌握关键技术且为我区重点发展产业急需紧缺的人才，可适当放宽学历、资历、职务、年龄条件。
                            <div style="font-weight: bold; margin-top: 0.22rem">
                                1. 创业个人一般应具备以下条件：
                            </div>
                            <div>（1）具有海外学位或国内硕士及以上学位。</div>
                            <div>
                                （2）具有海内外自主创业或行业领军企业的中高层任职经历，熟悉相关产业领域和国际规则，有较为丰富的科技成果转化、企业经营管理和市场开发运作经验，所创办企业对地方经济社会有较大影响和贡献。
                            </div>
                            <div>
                                （3）拥有自主知识产权或发明专利，其技术成果国内领先、国际先进，产品具有较大市场潜力。
                            </div>
                            <div>
                                （4）作为主要创办人（为第一大股东或者最大自然人股东，所占股权及实际出资比例均不低于30%）带项目、资金、技术来我区创业，具有独立法人资格，企业实缴资本不低于50万元，创业领域属于申报范围所列行业。
                            </div>
                            <div style="font-weight: bold; margin-top: 0.22rem">
                                2. 创新个人一般应具备以下条件：
                            </div>
                            <div>（1）具有博士学位或副高级及以上职称。</div>
                            <div>
                                （2）全职引进人才须在我区缴纳个税和社保，与区内用人单位签订连续5年及以上、剩余合同年限不少于3年、每年不少于9个月的正式工作合同。
                                “柔性”引进人才须与用人单位签订连续3年以上，每年不低于3个月的正式工作合同（含技术合作协议、项目合作协议），合同须明确具体的工作目标任务。
                            </div>
                            <div>（3）具备以下条件之一：</div>
                            <div>
                                ①在国内外知名高校、科研院所工作，与区内企业建立重大项目研究合作关系，研究成果能有效推进企业实现突破性发展的专家学者。
                            </div>
                            <div>
                                ②在国内外知名企业或研发机构有3年以上高级研发管理岗位工作经历，熟悉相关产业发展的专业技术人才。
                            </div>
                            <div>
                                ③承担过与国家科技重大项目相关的重要任务，具有较强的产品开发能力和产业化潜力的科技领军人才。
                            </div>
                            <div>
                                ④能够解决关键技术和工艺操作性难题，或自主创新产品达到国际先进、国内领先水平的产业领军人才。
                            </div>
                            <div style="font-weight: bold; margin-top: 0.22rem">
                                3．管理个人一般应具备以下条件：
                            </div>
                            <div>（1）具有海外学位或国内硕士及以上学位。</div>
                            <div>
                                （2）在我区缴纳个税和社保，与我区企业签订连续5年及以上全职工作劳动合同，剩余合同年限不少于3年。
                            </div>
                            <div>
                                （3）在我区非公企业担任董事长或总经理（总裁）。
                            </div>
                            <div>
                                （4）具有3年以上国内外相关行业领域知名企业中层及以上管理工作经历。
                            </div>
                            <div>
                                （5）具备现代企业经营管理经验，组织企业开展管理创新，建立现代管理体系，在发展战略、资本运作、市场开拓、科技和商业模式创新等相关方面成绩显著，对提升企业经营管理水平发挥重要作用。
                            </div>
                        </div>
                        <div class="title" style="
                                            font-weight: bold;
                                            font-size: 0.34rem;
                                            margin-top: 0.22rem;
                                        ">
                            <span class="hollow-cricle"></span>（二）直接认定条件
                        </div>
                        <div class="des">
                            已入选国家高层次人才特殊支持计划、国家海外高层次人才引进计划、“天府峨眉计划”“天府青城计划”或“蓉漂计划”的人才，经申报审核通过的，直接认定为“龙泉驿英才计划”相应层次人才，给予配套奖励（创新个人申报第（4）条情况除外）。
                        </div>
                    </div>
                </div>

                <div class="zccl">
                    <img class="top" src="./../assets/imgs/27/title-3.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="title">一. 资金支持</div>
                            A、B、C、D类人才分别享受200万元、100万元、50万元、20万元资助资金（分五年等额拨付）。
                        </div>
                        <div class="des">
                            <div class="title">二、住房保障</div>
                            按规定享受人才购房或人才公寓政策支持。
                        </div>
                        <div class="des">
                            <div class="title">三、子女入学</div>
                            按规定享受子女入学政策支持。
                        </div>
                        <div class="des">
                            <div class="title">四、体检疗养</div>
                            可享受我区组织的体检休疗活动。
                        </div>
                        <div class="des">
                            <div class="title">五、其他保障</div>
                            可申领“蓉城人才绿卡”驿都英才卡，享受政务办理、创新创业、生活休闲以及商务出行等服务保障。
                        </div>
                    </div>
                </div>
                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/55/title-4.png" alt="" />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">申报</div>
                                </div>
                                <div class="line-content">
                                    归口单位：区经信局、区新经济和科技局、区商务区
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">初审</div>
                                </div>
                                <div class="line-content">
                                    归口单位：区经信局、区新经济和科技局、区商务区
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">复审</div>
                                </div>
                                <div class="line-content">区委组织部</div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">4</div>
                                    <div class="line-title">评审</div>
                                </div>
                                <div class="line-content">
                                    专家评审团或第三方专业机构
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">5</div>
                                    <div class="line-title">审定</div>
                                </div>
                                <div class="line-content">
                                    区委人才工作领导小组
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line"></div>

                                    <div class="line-num">6</div>
                                    <div class="line-title">公示</div>
                                </div>
                                <div class="line-content"></div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line"></div>

                                    <div class="line-num">7</div>
                                    <div class="line-title">认定</div>
                                </div>
                                <div class="line-content"></div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">8</div>
                                    <div class="line-title">礼聘</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contact" style="margin-top: 0.8rem">
                    <img class="top" src="./../assets/imgs/25/title-5.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-84875086">028-84875086</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            区委组织部人才开发合作科
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/55/code.png" />
                    <img class="text" src="../assets/imgs/55/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                background: #ffffff;
                font-size: 0.26rem;
                color: #4e4e4e;
                text-align: left;
                position: relative;
                font-weight: 500;
                line-height: 0.44rem;

            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.22rem;
                    position: relative;
                }
            }
        }

        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    text-align: left;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 2.98rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    line-height: 0.44rem;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 130%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }

                        .line-top {
                            display: flex;
                            width: 3.31rem;
                            height: 0.49rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.08rem;

                            .line-num {
                                width: 0.39rem;
                                height: 0.39rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                height: 1.65rem;
            }
        }
    }
}
</style>
